import { createContext, useContext } from 'react';
import type { ToastContextValue } from './toastTypes';

export const ToastContext = createContext<ToastContextValue | null>(null);

/**
 * Hook to use toast functionality
 */
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
